"use client"

import { Tooltip } from "src/components/styled/Tooltip"
import { NpColor, NpColorValue } from "./NpColor"

export type NpColorOption = {
  name: string
  values: NpColorValue[]
}

export type NpColorsProps = {
  options: NpColorOption[]
}

export const NpColors = ({ options }: NpColorsProps) => {
  if (options.length < 2) {
    return null
  }

  return (
    <div className="inline-flex items-center justify-center gap-5 rounded-full">
      {options.map((opiton, index) => {
        return (
          <Tooltip key={index} text={opiton.name} placement="top">
            <NpColor key={index} values={opiton.values} />
          </Tooltip>
        )
      })}
    </div>
  )
}
